import * as React from 'react';

export const LineDisplayIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='124'
    height='124'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <path
      d='M15.4998 8.50066L15.4998 14.5007L1.49978 14.5007L1.49978 8.50075L15.4998 8.50066ZM15.4996 17.0007L15.4998 23.0007L1.49978 23.0008L1.49955 17.0007L15.4996 17.0007ZM14 18.5007L3 18.5007L3 21.5007L14 21.5007L14 18.5007ZM14 10.0007L3 10.0007L3 13.0007L14 13.0007L14 10.0007Z'
      fill='#004F9F'
    />
    <path
      d='M15.5 5.50089L9.5 5.50088L9.5 4L15.5 4L15.5 5.50089Z'
      fill='#004F9F'
    />
    <path
      d='M7.49955 5.50089L1.49955 5.50097L1.49955 4.00009L7.49955 4L7.49955 5.50089Z'
      fill='#004F9F'
    />
    <path
      d='M24 17.0008L20 23.0021L16.5 17.0008L18 17.0008L19.4 19.5018L19.45 4L20.9 4L20.849 19.5018L22.5 17.0008L24 17.0008Z'
      fill='#004F9F'
    />
  </svg>
);
